import ReCAPTCHA from './Recaptcha';
import makeAsyncScriptLoader from './async';

const callbackName = 'onloadcallback';
const lang =
    typeof window !== 'undefined' &&
    window.recaptchaOptions &&
    window.recaptchaOptions.lang
        ? `&hl=${window.recaptchaOptions.lang}`
        : '';
const url = `https://www.google.com/recaptcha/api.js?onload=${callbackName}&render=explicit${lang}`;
const globalName = 'grecaptcha';

export default makeAsyncScriptLoader(ReCAPTCHA, url, {
    callbackName,
    globalName,
    exposeFuncs: ['getValue', 'reset', 'execute'],
});
